import React from 'react';
import { Calendar, Clock } from 'lucide-react';
import {
  formatCalendarEventPreviewLine,
  parisDateTimeLocalToIso,
  HUBUP_PARIS_TZ,
} from '../../utils/hubupNotificationCalendarEvent';

export default function HubupNotificationCalendarEventPreview({ eventDraft }) {
  const title = String(eventDraft?.eventTitle ?? '').trim();
  const desc = String(eventDraft?.eventDesc ?? '').trim();
  const startIso = parisDateTimeLocalToIso(
    eventDraft?.startDate,
    eventDraft?.startTime,
  );
  const endIso =
    eventDraft?.specifyEnd &&
    parisDateTimeLocalToIso(eventDraft?.endDate, eventDraft?.endTime);

  const fmt = (iso) =>
    new Date(iso).toLocaleString('fr-FR', {
      timeZone: HUBUP_PARIS_TZ,
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });

  return (
    <div className="mx-auto min-w-0 max-w-lg pointer-events-none select-none">
      <div className="min-w-0 overflow-x-hidden rounded-3xl border border-[#E8E4FF] bg-white p-5 shadow-sm space-y-4">
        <div className="flex items-start gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-[#EEF1FA] text-[#010064]">
            <Calendar size={20} aria-hidden />
          </span>
          <div className="min-w-0">
            <h2 className="text-lg font-bold text-[#1E1B4B]">
              {title || (
                <span className="text-[#9CA3AF] font-normal italic">
                  Titre de l’événement
                </span>
              )}
            </h2>
            {desc ? (
              <p className="mt-2 text-sm text-[#333483] leading-relaxed whitespace-pre-wrap">
                {desc}
              </p>
            ) : (
              <p className="mt-2 text-sm text-[#9CA3AF] italic">
                Description (optionnelle)
              </p>
            )}
          </div>
        </div>

        {startIso ? (
          <div className="rounded-2xl border border-[#E8E4FF] bg-[#FAFBFC] px-4 py-3 space-y-2 text-sm text-[#333483]">
            <div className="flex items-center gap-2">
              <Clock size={16} className="text-[#010064] shrink-0" aria-hidden />
              <span>
                <span className="font-semibold text-[#1E1B4B]">Début · </span>
                {fmt(startIso)}
              </span>
            </div>
            {endIso ? (
              <div className="flex items-center gap-2 pl-6">
                <span>
                  <span className="font-semibold text-[#1E1B4B]">Fin · </span>
                  {fmt(endIso)}
                </span>
              </div>
            ) : (
              <p className="text-xs text-[#6B7280] pl-6">
                Fin par défaut : 1 h après le début
              </p>
            )}
          </div>
        ) : (
          <p className="text-sm text-[#6B7280] italic text-center py-4">
            Renseignez la date et l’heure de début.
          </p>
        )}

        {!title && !startIso ? (
          <p className="text-xs text-center text-[#9CA3AF]">
            {formatCalendarEventPreviewLine(eventDraft) || 'Aperçu calendrier'}
          </p>
        ) : null}
      </div>
    </div>
  );
}
